<template>
  <div class="c-app flex-row align-items-center amsys-header">
    <CWrapper>
      <CHeader fixed with-subheader light style="position: fixed;">
        <CToggler
          in-header
          class="ml-3 d-lg-none"
          @click="$store.commit('toggleSidebarMobile')"
          style="position: fixed;margin-top: 1em;"
        />
        <CHeaderBrand class="d-lg-none" style="margin-left: 5em;">
          <img src="img/header.png" style="max-width:12em; text-align:left;" />
        </CHeaderBrand>
      </CHeader>
      <div class="c-body">
        <main class="c-main">
          <CRow
            style="margin-right:0px !important; margin-left:0px !important;"
          >
            <div
              @click="clickOnDCP()"
              v-if="DashboardCoalProduction"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img
                src="img/CoalStock.png"
                class="c-avatar-img amsys-img-icon"
              />
              <label class="amsys-label-icon"><b>COAL PRODUCTION</b></label>
            </div>
            <div
              @click="clickOnDpr()"
              v-if="DashboardProduction"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img
                src="img/dashboard.png"
                class="c-avatar-img amsys-img-icon"
              />
              <label class="amsys-label-icon"><b>PRODUCTION</b></label>
            </div>
            <div
              @click="clickOnDP()"
              v-if="DashboardProfitLoss"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img
                src="img/dashboard1.png"
                class="c-avatar-img amsys-img-icon"
              />
              <label class="amsys-label-icon"
                ><b>DASHBOARD PROFIT LOSS</b></label
              >
            </div>
            <div
              @click="clickOnDCS()"
              v-if="DashboardCoalSales"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img
                src="img/dashboard2.png"
                class="c-avatar-img amsys-img-icon"
              />
              <label class="amsys-label-icon"
                ><b>DASHBOARD COAL SALES</b></label
              >
              <!--<label>Hauling Info</label>-->
            </div>
            <div
              @click="clickOnDH()"
              v-if="DashboardHauling"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img
                src="img/dashboard3.png"
                class="c-avatar-img amsys-img-icon"
              />
              <label class="amsys-label-icon"
                ><b>DASHBOARD HAULING DISCHARGE</b></label
              >
              <!--<label>Hauling Info</label>-->
            </div>
            <div
              @click="clickOnMo()"
              v-if="DashboardMiningOperation"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img
                src="img/dashboardMop.png"
                class="c-avatar-img amsys-img-icon"
              />
              <label class="amsys-label-icon"
                ><b>DASHBOARD MINING OPERATION</b></label
              >
              <!--<label>Hauling Info</label>-->
            </div>
            <div
              @click="clickOnDHS()"
              v-if="DashboardHaulingSite"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img
                src="img/dashboard4.png"
                class="c-avatar-img amsys-img-icon"
              />
              <label class="amsys-label-icon"
                ><b>DASHBOARD HAULING SITE</b></label
              >
              <!--<label>Hauling Info</label>-->
            </div>
            <div
              @click="clickOnHRM()"
              v-if="DashboardHrm"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img
                src="img/dashboard5.png"
                class="c-avatar-img amsys-img-icon"
              />
              <label class="amsys-label-icon"><b>DASHBOARD HRM</b></label>
              <!--<label>Hauling Info</label>-->
            </div>
            <div
              @click="clickOnCI()"
              v-if="CoalInventory"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img
                src="img/CoalInventory.png"
                class="c-avatar-img amsys-img-icon"
              />
              <label class="amsys-label-icon"><b>COAL INVENTORY</b></label>
              <!--<label>Hauling Info</label>-->
            </div>
            <div
              @click="clickOnBudget()"
              v-if="Budget"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img src="img/budget.png" class="c-avatar-img amsys-img-icon" />
              <label class="amsys-label-icon"><b>BUDGET</b></label>
              <!--<label>Hauling Info</label>-->
            </div>
            <!--<div @click="clickOnCS()" v-if="CoalStock" class="col-sm-6 col-md-x amsys-approval-cardx2" style="text-align:center">
                                    <img src="img/CoalStock.png" class="c-avatar-img amsys-img-icon" />
                                    <label class="amsys-label-icon"><b>COAL STOCK</b></label>
                                    </div>-->
            <div
              @click="clickOnHI()"
              v-if="HaulingInfo"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img
                src="img/HaulingInfo.png"
                class="c-avatar-img amsys-img-icon"
              />
              <label class="amsys-label-icon"><b>HAULING INFO</b></label>
              <!--<label>Hauling Info</label>-->
            </div>

            <div
              @click="clickOnAp()"
              v-if="Approval"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img src="img/Approve.png" class="c-avatar-img amsys-img-icon" />
              <label class="amsys-label-icon"><b>APPROVAL</b></label>
              <!--<label>Hauling Info</label>-->
            </div>
            <div
              @click="clickOnVECA()"
              v-if="ApprovalVECA"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img src="img/Approve.png" class="c-avatar-img amsys-img-icon" />
              <label class="amsys-label-icon"><b>APPROVAL VECA</b></label>
              <!--<label>Hauling Info</label>-->
            </div>
            <div
              @click="clickOnAH()"
              v-if="ApprovalHistory"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img
                src="img/ApprovalHistory.png"
                class="c-avatar-img amsys-img-icon"
              />
              <label class="amsys-label-icon"><b>APPROVAL HISTORY </b></label>
              <!--<label>Hauling Info</label>-->
            </div>
            <div
              @click="clickOnAHVECA()"
              v-if="HistoryVECA"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img
                src="img/ApprovalHistory.png"
                class="c-avatar-img amsys-img-icon"
              />
              <label class="amsys-label-icon"
                ><b>APPROVAL HISTORY VECA</b></label
              >
              <!--<label>Hauling Info</label>-->
            </div>
            <div
              @click="qrcode()"
              v-if="QrCode"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img
                src="img/dashboard6.png"
                class="c-avatar-img amsys-img-icon"
              />
              <label class="amsys-label-icon"><b>QR SCANNER</b></label>
              <!--<label>Hauling Info</label>-->
            </div>
            <div
              @click="showModalShortcut()"
              class="col-sm-6 col-md-x amsys-approval-cardx2"
              style="text-align:center"
            >
              <img src="img/more1.png" class="c-avatar-img amsys-img-icon" />
              <label class="amsys-label-icon"><b>MORE</b></label>
            </div>
          </CRow>
          <CRow class="justify-content-center">
            <div id="loading-contentx" v-if="loading"></div>
          </CRow>
        </main>
      </div>
    </CWrapper>
    <CModal
      size="lg"
      :show.sync="modalShortcut"
      color="info"
      style="font-size: 15px;"
    >
      <font style="font-size:15px; width: 80%;"><b>LIST MENU</b></font>
      <br />
      <br />
      <table>
        <tr v-if="_navDashboardCoalProduction">
          <td>
            Dashboard Coal Production
          </td>
          <td>
            <label class="mx-1 c-switch form-check-label c-switch-3d-success">
              <input
                type="checkbox"
                class="c-switch-input form-check-input"
                v-model="DashboardCoalProduction"
              />
              <span class="c-switch-slider"> </span>
            </label>
          </td>
        </tr>
        <tr v-if="_navDashboardProduction">
          <td>
            Dashboard Production
          </td>
          <td>
            <label class="mx-1 c-switch form-check-label c-switch-3d-success">
              <input
                type="checkbox"
                class="c-switch-input form-check-input"
                v-model="DashboardProduction"
              />
              <span class="c-switch-slider"> </span>
            </label>
          </td>
        </tr>
        <tr v-if="_navDashboardProfitLoss">
          <td>
            Dashboard Profit Loss
          </td>
          <td>
            <label class="mx-1 c-switch form-check-label c-switch-3d-success">
              <input
                type="checkbox"
                class="c-switch-input form-check-input"
                v-model="DashboardProfitLoss"
              />
              <span class="c-switch-slider"> </span>
            </label>
          </td>
        </tr>
        <tr v-if="_navDashboardCoalSales">
          <td>
            Dashboard Coal Sales
          </td>
          <td>
            <label class="mx-1 c-switch form-check-label c-switch-3d-success">
              <input
                type="checkbox"
                class="c-switch-input form-check-input"
                v-model="DashboardCoalSales"
              />
              <span class="c-switch-slider"> </span>
            </label>
          </td>
        </tr>
        <tr v-if="_navDashboardHauling">
          <td>
            Dashboard Hauling Discharge
          </td>
          <td>
            <label class="mx-1 c-switch form-check-label c-switch-3d-success">
              <input
                type="checkbox"
                class="c-switch-input form-check-input"
                v-model="DashboardHauling"
              />
              <span class="c-switch-slider"> </span>
            </label>
          </td>
        </tr>
        <tr v-if="_navDashboardHaulingSite">
          <td>
            Dashboard Hauling Site
          </td>
          <td>
            <label class="mx-1 c-switch form-check-label c-switch-3d-success">
              <input
                type="checkbox"
                class="c-switch-input form-check-input"
                v-model="DashboardHaulingSite"
              />
              <span class="c-switch-slider"> </span>
            </label>
          </td>
        </tr>
        <tr v-if="_navDashboardMiningOperation">
          <td>
            Dashboard Mining Operation
          </td>
          <td>
            <label class="mx-1 c-switch form-check-label c-switch-3d-success">
              <input
                type="checkbox"
                class="c-switch-input form-check-input"
                v-model="DashboardMiningOperation"
              />
              <span class="c-switch-slider"> </span>
            </label>
          </td>
        </tr>
        <tr v-if="_navDashboardHrm">
          <td>
            Dashboard HRM
          </td>
          <td>
            <label class="mx-1 c-switch form-check-label c-switch-3d-success">
              <input
                type="checkbox"
                class="c-switch-input form-check-input"
                v-model="DashboardHrm"
              />
              <span class="c-switch-slider"> </span>
            </label>
          </td>
        </tr>
        <tr v-if="_navCoalInventory">
          <td>
            Coal Inventory
          </td>
          <td>
            <label class="mx-1 c-switch form-check-label c-switch-3d-success">
              <input
                type="checkbox"
                class="c-switch-input form-check-input"
                v-model="CoalInventory"
              />
              <span class="c-switch-slider"> </span>
            </label>
          </td>
        </tr>
        <tr v-if="_navApproval">
          <td>
            Approval
          </td>
          <td>
            <label class="mx-1 c-switch form-check-label c-switch-3d-success">
              <input
                type="checkbox"
                class="c-switch-input form-check-input"
                v-model="Approval"
              />
              <span class="c-switch-slider"> </span>
            </label>
          </td>
        </tr>
        <tr v-if="_navApprovalVeca">
          <td>
            Approval Veca
          </td>
          <td>
            <label class="mx-1 c-switch form-check-label c-switch-3d-success">
              <input
                type="checkbox"
                class="c-switch-input form-check-input"
                v-model="ApprovalVECA"
              />
              <span class="c-switch-slider"> </span>
            </label>
          </td>
        </tr>
        <tr v-if="_navHistoryVeca">
          <td>
            Approval History Veca
          </td>
          <td>
            <label class="mx-1 c-switch form-check-label c-switch-3d-success">
              <input
                type="checkbox"
                class="c-switch-input form-check-input"
                v-model="HistoryVECA"
              />
              <span class="c-switch-slider"> </span>
            </label>
          </td>
        </tr>
        <tr v-if="_navApprovalHistory">
          <td>
            Approval History
          </td>
          <td>
            <label class="mx-1 c-switch form-check-label c-switch-3d-success">
              <input
                type="checkbox"
                class="c-switch-input form-check-input"
                v-model="ApprovalHistory"
              />
              <span class="c-switch-slider"> </span>
            </label>
          </td>
        </tr>
        <tr v-if="_navBudget">
          <td>
            Budget
          </td>
          <td>
            <label class="mx-1 c-switch form-check-label c-switch-3d-success">
              <input
                type="checkbox"
                class="c-switch-input form-check-input"
                v-model="Budget"
              />
              <span class="c-switch-slider"> </span>
            </label>
          </td>
        </tr>
        <!--<tr v-if="_navCoalStock">
                            <td>
                                Coal Stock
                            </td>
                            <td>
                                <label class="mx-1 c-switch form-check-label c-switch-3d-success">
                                    <input type="checkbox" class="c-switch-input form-check-input" v-model="CoalStock">
                                    <span class="c-switch-slider">
                                    </span>
                                </label>
                            </td>
                        </tr>-->
        <tr v-if="_navHaulingInfo">
          <td>
            HaulingInfo
          </td>
          <td>
            <label class="mx-1 c-switch form-check-label c-switch-3d-success">
              <input
                type="checkbox"
                class="c-switch-input form-check-input"
                v-model="HaulingInfo"
              />
              <span class="c-switch-slider"> </span>
            </label>
          </td>
        </tr>
        <tr v-if="_navQrCode">
          <td>
            Qr Code
          </td>
          <td>
            <label class="mx-1 c-switch form-check-label c-switch-3d-success">
              <input
                type="checkbox"
                class="c-switch-input form-check-input"
                v-model="QrCode"
              />
              <span class="c-switch-slider"> </span>
            </label>
          </td>
        </tr>
      </table>

      <br />
      <template #footer>
        <CButton
          @click="modalShortcut = false"
          color="secondary"
          style="font-size: 15px;"
          >Close</CButton
        >
        <CButton
          @click="actionSaveMenu()"
          style="font-size: 15px;"
          class="btn btn-info"
        >
          OK
        </CButton>
      </template>
    </CModal>
    <CModal
      size="lg"
      :show.sync="modalQr"
      color="info"
      style="font-size: 15px;text-align:center;"
    >
      <font style="font-size:15px; width: 80%; "><b>RESULT QR CODE</b></font>
      <br />
      <table>
        <tr>
          <td colspan="2" style="text-align:center;">
            <img :src="src" style="width: 135px;height: 140px;" />
          </td>
        </tr>
        <tr>
          <td>
            Nama
          </td>
          <td>
            {{ this.name }}
          </td>
        </tr>
      </table>

      <br />
      <template #footer>
        <CButton
          @click="modalShortcut = false"
          color="secondary"
          style="font-size: 15px;"
          hidden
          >Close</CButton
        >
        <CButton
          @click="actionSaveMenu()"
          style="font-size: 15px;"
          class="btn btn-info"
          hidden
        >
          OK
        </CButton>
      </template>
    </CModal>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import "@babel/polyfill";
import VueCordova from "vue-cordova";
import VueApexCharts from "vue-apexcharts";
import CryptoJS from "crypto-js";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);
Vue.use(VueCordova);
export default {
  data() {
    return {
      show: true,
      modalShortcut: false,
      modalQr: false,
      loading: false,
      src: "",
      name: "",
      DashboardCoalProduction: false,
      _navDashboardCoalProduction: false,
      _navDashboardProfitLoss: false,
      _navDashboardCoalSales: false,
      _navDashboardHauling: false,
      _navDashboardHaulingSite: false,
      _navCoalInventory: false,
      _navApprovalHistory: false,
      _navDashboard: false,
      _navApproval: false,
      _navApprovalVeca: false,
      _navHistoryVeca: false,
      _navBudget: false,
      _navCoalStock: false,
      _navHaulingInfo: false,
      _navDashboardHrm: false,
      _navDashboardMiningOperation: false,
      _navQrCode: false,
      _navDashboardProduction: false,

      navDashboardCoalProduction: false,
      navDashboardProfitLoss: false,
      navDashboardCoalSales: false,
      navDashboardHauling: false,
      navDashboardHaulingSite: false,
      navCoalInventory: false,
      navApprovalHistory: false,
      navDashboard: false,
      navApproval: false,
      navApprovalVeca: false,
      navHistoryVeca: false,
      navBudget: false,
      navCoalStock: false,
      navHaulingInfo: false,
      navDashboardHrm: false,
      navDashboardMiningOperation: false,
      navQrCode: false,
      navDashboardProduction: false,

      DashboardCoalProduction: false,
      DashboardProfitLoss: false,
      DashboardCoalSales: false,
      DashboardHauling: false,
      DashboardHaulingSite: false,
      CoalInventory: false,
      ApprovalHistory: false,
      Dashboard: false,
      Approval: false,
      ApprovalVECA: false,
      HistoryVECA: false,
      Budget: false,
      CoalStock: false,
      HaulingInfo: false,
      DashboardHrm: false,
      DashboardMiningOperation: false,
      QrCode: false,
      DashboardProduction: false,

      urlServer: "",
    };
  },
  methods: {
    async qrcode1() {
      let data = localStorage.token;
      const formData = new FormData();
      formData.append("Oid", "F02A849C-8D4F-48E9-BA07-96013C4297BD");
      let sendData = JSON.stringify(Object.fromEntries(formData));
      axios
        .post(`${this.urlServer}/Api/General/GetInformationQrCode/`, sendData, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          var data = res.data[0];
          if (data.Photo == null) {
            this.src = "";
          } else {
            var fileURL = "data:application/png;base64," + data.Photo;
            this.src = fileURL;
          }
          this.name = data.Name;
          this.modalQr = true;
          console.log(res);
        })
        .catch((error) => {
          this.modalQr = false;
          let err = error.toString();
          if (err.toString().match(/^.*undefined.*$/)) {
            Vue.$toast.open({
              message: "Sorry, Your token has expired!",
              type: "warning",
              position: "bottom",
            });
          } else {
            Vue.$toast.open({
              message: error,
              type: "error",
              position: "bottom",
            });
          }
        });
    },
    async qrcode() {
      let data = localStorage.token;
      cordova.plugins.barcodeScanner.scan(
        function(result) {
          console.log(result.text);
          if (result.text != "") {
            var Oid = result.text;
            if (typeof data == "undefined") {
              this.$router.push({ path: "/logout" });
            } else {
              const formData = new FormData();
              formData.append("Oid", Oid);
              let sendData = JSON.stringify(Object.fromEntries(formData));
              axios
                .post("/Api/General/GetInformationQrCode/", sendData, {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + data,
                  },
                })
                .then((res) => {
                  alert(res.data[0].Company);
                  console.log(res);
                })
                .catch((error) => {
                  let err = error.toString();
                  if (err.toString().match(/^.*undefined.*$/)) {
                    Vue.$toast.open({
                      message: "Sorry, Your token has expired!",
                      type: "warning",
                      position: "bottom",
                    });
                  } else {
                    Vue.$toast.open({
                      message: error,
                      type: "error",
                      position: "bottom",
                    });
                  }
                });
            }
          } else {
          }
        },
        function(error) {
          alert("Scanning failed: " + error);
        },
        {
          preferFrontCamera: false, // iOS and Android
          showFlipCameraButton: true, // iOS and Android
          showTorchButton: true, // iOS and Android
          torchOn: true, // Android, launch with the torch switched on (if available)
          saveHistory: true, // Android, save scan history (default false)
          //prompt : "Place a barcode inside the scan area", // Android
          prompt: "Scan QR Code di area ini",
          resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
          formats: "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
          orientation: "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
          disableAnimations: false, // iOS
          disableSuccessBeep: false, // iOS and Android
        }
      );
    },
    clickOnDCP() {
      this.$router.push({ path: "/CoalProduction" });
    },
    clickOnDH() {
      this.$router.push({ path: "/DashboardHauling" });
    },
    clickOnDHS() {
      this.$router.push({ path: "/DashboardHaulingSite" });
    },
    clickOnHRM() {
      this.$router.push({ path: "/DashboardHrm" });
    },
    clickOnDP() {
      this.$router.push({ path: "/ProfitLoss" });
    },
    clickOnDCS() {
      this.$router.push({ path: "/CoalSales" });
    },
    clickOnCI() {
      this.$router.push({ path: "/CoalInventory" });
    },
    clickOnBudget() {
      this.$router.push({ path: "/Budget" });
    },
    clickOnHI() {
      this.$router.push({ path: "/hauling" });
    },
    clickOnMo() {
      this.$router.push({ path: "/DashboardMiningOperation" });
    },
    clickOnAp() {
      this.$router.push({ path: "/approval" });
    },
    clickOnVECA() {
      this.$router.push({ path: "/ApprovalVeca" });
    },
    clickOnAH() {
      this.$router.push({ path: "/History" });
    },
    clickOnAHVECA() {
      this.$router.push({ path: "/HistoryVeca" });
    },
    clickOnDpr() {
      this.$router.push({ path: "/DashboardProduction" });
    },
    showModalShortcut() {
      let dataNav = localStorage.navigation;
      if (dataNav !== undefined || dataNav != null || dataNav != "") {
        let nav = JSON.parse(localStorage.navigation);
        this._navDashboardCoalProduction = nav[0].DashboardCoalProduction;
        this._navDashboardProfitLoss = nav[0].DashboardProfitLoss;
        this._navDashboardCoalSales = nav[0].DashboardCoalSales;
        this._navDashboardHauling = nav[0].DashboardHauling;
        this._navDashboardHaulingSite = nav[0].DashboardHaulingSite;
        this._navDashboardHrm = nav[0].DashboardHrm;
        this._navCoalInventory = nav[0].CoalInventory;
        this._navApprovalHistory = nav[0].ApprovalHistory;
        this._navApproval = nav[0].Approval;
        this._navApprovalVeca = nav[0].ApprovalVeca;
        this._navHistoryVeca = nav[0].ApprovalVeca;
        this._navBudget = nav[0].Budget;
        this._navCoalStock = nav[0].CoalStock;
        this._navHaulingInfo = nav[0].HaulingInfo;
        this._navDashboardMiningOperation = nav[0].DashboardMiningOperation;
        this._navDashboardProduction = nav[0].DashboardProduction;
        this._navQrCode = nav[0].QrCode;
        this.modalShortcut = true;
      }
    },
    async reloadData() {
      let self = this;
      let dataNav = localStorage.navigation;
      console.log("DATA NAVIGASI", JSON.parse(localStorage.navigation));
      if (dataNav !== undefined || dataNav != null || dataNav != "") {
        let nav = JSON.parse(localStorage.navigation);
        this._navDashboardCoalProduction = nav[0].DashboardCoalProduction;
        this._navDashboardProfitLoss = nav[0].DashboardProfitLoss;
        this._navDashboardCoalSales = nav[0].DashboardCoalSales;
        this._navDashboardHauling = nav[0].DashboardHauling;
        this._navDashboardHaulingSite = nav[0].DashboardHaulingSite;
        this._navCoalInventory = nav[0].CoalInventory;
        this._navApprovalHistory = nav[0].ApprovalHistory;
        this._navApproval = nav[0].Approval;
        this._navApprovalVeca = nav[0].ApprovalVeca;
        this._navHistoryVeca = nav[0].ApprovalVeca;
        this._navBudget = nav[0].Budget;
        this._navCoalStock = nav[0].CoalStock;
        this._navHaulingInfo = nav[0].HaulingInfo;
        this._navDashboardHrm = nav[0].DashboardHrm;
        this._navDashboardMiningOperation = nav[0].DashboardMiningOperation;
        this._navDashboardProduction = nav[0].DashboardProduction;
        this._navQrCode = nav[0].QrCode;

        let data = localStorage.token;
        await axios
          .post(`${this.urlServer}/Api/General/GetAccessMenuMobile/`, "", {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
              "Access-Control-Allow-Headers":
                "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
              "Content-Type": "application/json",
              Authorization: "Bearer " + data,
            },
          })
          .then((res) => {
            let nav = res.data;
            console.log("NAVIGASI", nav);
            this.DashboardCoalProduction = nav[0].DashboardCoalProduction;
            this.DashboardProfitLoss = nav[0].DashboardProfitLoss;
            this.DashboardCoalSales = nav[0].DashboardCoalSales;
            this.DashboardHauling = nav[0].DashboardHauling;
            this.DashboardHaulingSite = nav[0].DashboardHaulingSite;
            this.CoalInventory = nav[0].CoalInventory;
            this.ApprovalHistory = nav[0].ApprovalHistory;
            this.Approval = nav[0].Approval;

            this.Budget = nav[0].Budget;
            this.CoalStock = nav[0].CoalStock;
            this.HaulingInfo = nav[0].HaulingInfo;
            this.DashboardHrm = nav[0].DashboardHrm;
            this.DashboardMiningOperation = nav[0].DashboardMiningOperation;
            this.DashboardProduction = nav[0].DashboardProduction;
            this.QrCode = nav[0].QrCode;

            cordova.plugins.firebase.messaging
              .requestPermission({ forceShow: false })
              .then(function() {
                console.log("Push messaging is allowed");
                cordova.plugins.firebase.messaging
                  .getToken()
                  .then(function(token) {
                    console.log("Got device token: ", token);
                    self.saveUserInformationNotif(token);
                  });
              });
          })
          .catch((error) => {
            Vue.$toast.open({
              message: error,
              type: "error",
              position: "bottom",
            });
          });
      } else {
      }
    },
    async saveUserInformationNotif(tokenFCM) {
      const data = localStorage.token;
      const dModel = localStorage.getItem("deviceModel");
      const mAddress = null;
      const form = new FormData();
      form.append("FcmTokenID", tokenFCM);
      form.append("DeviceName", dModel);
      form.append("MacAddress", mAddress);
      let sendData = JSON.stringify(Object.fromEntries(form));
      await axios
        .post(`${this.urlServer}/Api/General/SaveUserInformation/`, sendData, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          console.log(res);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async actionSaveMenu() {
      let data = localStorage.token;
      const form = new FormData();
      form.append("DashboardCoalProduction", this.DashboardCoalProduction);
      form.append("DashboardProfitLoss", this.DashboardProfitLoss);
      form.append("DashboardCoalSales", this.DashboardCoalSales);
      form.append("DashboardHauling", this.DashboardHauling);
      form.append("DashboardHaulingSite", this.DashboardHaulingSite);
      form.append("CoalInventory", this.CoalInventory);
      form.append("ApprovalHistory", this.ApprovalHistory);
      form.append("DashboardHrm", this.DashboardHrm);
      form.append("Approval", this.Approval);
      form.append("ApprovalVeca", this.ApprovalVECA);
      form.append("Budget", this.Budget);
      form.append("CoalStock", this.CoalStock);
      form.append("HaulingInfo", this.HaulingInfo);
      form.append("DashboardMiningOperation", this.DashboardMiningOperation);
      form.append("DashboardProduction", this.DashboardProduction);
      form.append("QrCode", this.QrCode);
      let sendData = JSON.stringify(Object.fromEntries(form));
      await axios
        .post(`${this.urlServer}/Api/General/UpdateMenuShortcut/`, sendData, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            "Content-Type": "application/json",
            Authorization: "Bearer " + data,
          },
        })
        .then((res) => {
          this.reloadData();
          this.modalShortcut = false;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  beforeMount() {
    const stringToProtect = "Amsys_2@2021";
    let url = CryptoJS.AES.decrypt(localStorage.url, stringToProtect);
    this.urlServer = url.toString(CryptoJS.enc.Utf8);
    console.log(this.urlServer);
    this.reloadData();
    //this.qrcode1();
  },
};
</script>
